export const MAINTENANCE_FORM_NAME = 'nimpeeMaintenanceForm';
